import { DeleteProviderBulkInput, DeleteProviderBulkResponse, DeleteProviderInput } from '@/models/gen/graphql';
import { createNotification, handleError } from '@/utils';

import { DeleteAirlineBulkDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import { Toast } from '@/models';
import graphApi from '@/api';

type DeleteAirlineBulkGraphApiResponse = GraphApiResponse<typeof DeleteAirlineBulkDocument>;

const title = 'Delete Airlines';

const deleteAirlineBulkResponseSelector = (res: DeleteAirlineBulkGraphApiResponse): DeleteProviderBulkResponse =>
  !res.errors ? res?.deleteAirlineBulk : undefined;

const [runDeleteAirlineBulk] = graphApi(DeleteAirlineBulkDocument, {
  onError: (res: DeleteAirlineBulkGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const deleteAirlineBulk = async (ids: string[]): Promise<DeleteProviderBulkResponse> => {
  const input: DeleteProviderBulkInput = { search: ids.map((id: string): DeleteProviderInput => ({ id })) };
  const res = await runDeleteAirlineBulk({ input });

  const selected = deleteAirlineBulkResponseSelector(res);
  if (selected) createNotification('Success', Toast.Type.SUCCESS, title);
  return selected;
};

export default deleteAirlineBulk;
